export default __webpack_public_path__ + "static/media/scratch-card-image.705f5195.svg";